// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Trafico from './Pages/Trafico';
import TraficoPorRecoger from './Pages/TraficoPorRecoger';
import Trayecto from './Pages/Trayecto';
import Login from './Pages/Login';
import Historico from './Pages/Historico';
import Reportes from './Pages/Reportes';
import Roles from './Pages/Roles';
import Usuarios from './Pages/Usuarios';
import ControlDevices from './Pages/ControlDevices';
import ControlDevice from './Pages/ControlDevice';
import AzureUpload from './Pages/AzureUpload';
import AuthenticatedApp from "./AuthenticatedApp";
import Solicitudes from "./Pages/Solicitudes";
import Principal from "./Pages/Principal";
import MyProfile from "./Pages/MyProfile";
import Valitronics from "./Pages/Valitronics";
import CrearContrato2 from "./Pages/CrearContrato2";
import ReporteTabla2 from "./Modulos/ReporteTabla2";
import ReporteTabla3 from "./Modulos/ReporteTabla3";
import ReporteTabla from "./Modulos/ReporteTabla";
import ControlContracts from "./Pages/ControlContracts";
import MapCenter from "./Modulos/MapCenter";
import Geocercas2 from "./Modulos/Geocercas2";
import Maestros from "./Pages/Maestros";
import Empresas from "./Pages/Empresas";
import TraficoOculto from "./Pages/TraficoOculto";
import EdicionTrakaphoto from "./Pages/EdicionTrakaphoto";
import MovimientoUsuario from "./Pages/MovimientoUsuario";
import ReporteAutoDownload from "./Modulos/ReporteAutoDowload";
import ReporteToPdfStatic from "./Pages/ReporteToPdfStatic";
import ReporteToPdfReactPDF from "./Pages/ReporteToPdfReactPDF";
import NotFound from "./Pages/NotFound";
import Home from "./Pages/Home";
import ConfigLives from "./Pages/ConfigLives";
import PublicReportes from "./Pages/PublicReportes";
import { AuthProvider } from "./auth/AuthContext";
import PublicOnlyRoute from "./auth/PublicOnlyRoute";

function App() {
    // Función para bloquear la navegación de flechas en los selects
    const handleKeyDown = (e) => {
        if (e.target.tagName === 'SELECT' && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
            e.preventDefault(); // Evitar la navegación con las flechas en los <select>
        }
    };

    // useEffect que registra el evento global para todos los select
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup: Remover el event listener cuando se desmonte el componente App
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <Router>
          <AuthProvider>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route element={<PublicOnlyRoute />}>
                    <Route path="/login" element={<Login />} />
                </Route>
                <Route path="/gdpr" element={<Home />} />
                <Route path="/terminos-condiciones" element={<Home />} />
                <Route path="/politicas-privacidad" element={<Home />} />
                <Route path="/reportes-publicos" element={<PublicReportes />} />
                <Route path="/reportes-publicos/:publicToken" element={<PublicReportes />} />
                <Route element={<AuthenticatedApp><Outlet /></AuthenticatedApp>}>
                    <Route path="/principal" element={<Principal />} />
                    <Route path="/trafico" element={<Trafico />} />
                    <Route path="/trafico_por_recoger" element={<TraficoPorRecoger />} />
                    <Route path="/trayecto" element={<Trayecto />} />
                    <Route path="/historico" element={<Historico />} />
                    <Route path="/reportes" element={<Reportes />} />
                    <Route path="/roles" element={<Roles />} />
                    <Route path="/usuarios" element={<Usuarios />} />
                    <Route path="/controldevices" element={<ControlDevices />} />
                    <Route path="/controldevice" element={<ControlDevice />} />
                    <Route path="/azureupload" element={<AzureUpload />} />
                    <Route path="/solicitudes" element={<Solicitudes />} />
                    <Route path="/myprofile" element={<MyProfile />} />
                    <Route path="/valitronics" element={<Valitronics />} />
                    <Route path="/crearContrato2" element={<CrearContrato2 />} />
                    <Route path="/controlContracts" element={<ControlContracts />} />
                    <Route path="/mapCenter" element={<MapCenter />} />
                    <Route path="/geocercas2" element={<Geocercas2 />} />
                    <Route path="/maestros" element={<Maestros />} />
                    <Route path="/empresas" element={<Empresas />} />
                    <Route path="/trafico_oculto" element={<TraficoOculto />} />
                    <Route path="/ediciontrakaphoto" element={<EdicionTrakaphoto />} />
                    <Route path="/movimientos_usuario" element={<MovimientoUsuario />} />
                    <Route path="/lives_config" element={<ConfigLives />} />
                    {/* <Route path="/reportelink/:contratoId" element={<ReporteAutoDownload />} /> */}
                    <Route path="/reporte-static/:contratoId" element={<ReporteToPdfReactPDF />} />
                    {/* <Route path="/reporteTabla2" element={<ReporteTabla2 />} />*/}
                    <Route path="/reporteTabla3" element={<ReporteTabla3 />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
          </AuthProvider>
        </Router>
    );
}

export default App;
